import * as GroupType from 'constants/GroupType';

const ICE_HOCKEY_GROUP_MAP = {};

ICE_HOCKEY_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
ICE_HOCKEY_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
ICE_HOCKEY_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
ICE_HOCKEY_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
ICE_HOCKEY_GROUP_MAP[4] = GroupType.ICE_HOCKEY_FIRST_MINI_MATCH_GROUP;
ICE_HOCKEY_GROUP_MAP[5] = GroupType.ICE_HOCKEY_SECOND_MINI_MATCH_GROUP;
ICE_HOCKEY_GROUP_MAP[6] = GroupType.ICE_HOCKEY_THIRD_MINI_MATCH_GROUP;
ICE_HOCKEY_GROUP_MAP[7] = GroupType.ICE_HOCKEY_FOURTH_MINI_MATCH_GROUP;
ICE_HOCKEY_GROUP_MAP[8] = GroupType.ICE_HOCKEY_FIFTH_MINI_MATCH_GROUP;
ICE_HOCKEY_GROUP_MAP[9] = GroupType.ICE_HOCKEY_SIXTH_MINI_MATCH_GROUP;

export default ICE_HOCKEY_GROUP_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/IceHockey/GroupMap.js